import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notice-press25',
  templateUrl: './notice-press25.component.html',
  styleUrls: ['./notice-press25.component.scss']
})
export class NoticePress25Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
